export default __webpack_public_path__ + "static/media/import_cross.d7f4b0d8.svg";